<template>
  <div
    @keydown.up.prevent="onArrowUp"
    @keydown.down.prevent="onArrowDown"
    @keydown.esc.prevent="$emit('update:isPopupOpen', false)"
    class="suggest-box popover b-popover">
    <div class="d-block">
      <div class="list-group list-group-flush" data-cy="suggest-value-list">
        <a
          v-if="!displayValuesWithValue.length > 0"
          class="suggest-box-entry list-group-item d-flex justify-content-between align-items-center list-group-item-action no-suggestion">
          <span
            ><em>{{ $t("NoSuggestions") }}</em></span
          >
        </a>
        <a
          v-for="(item, i) in displayValuesWithValue"
          :key="i"
          ref="suggestValues"
          href="#"
          @click.prevent="onValueSelected(item.value)"
          class="suggest-box-entry list-group-item d-flex justify-content-between align-items-center list-group-item-action"
          :class="{ active: item.value && value === item.value }"
          tabindex="-1"
          data-cy="suggest-value-list-item">
          <span class="suggestion-value" v-tooltip.ellipsis.mouse="item.value">{{ item.value }}</span>
          <span class="suggestion-count text-secondary pl-3">{{ item.count == -1 ? "" : item.count }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import suggestapi from "@services/suggest.js";
export default {
  props: [
    "value",
    "field",
    "attributeType",
    "attributeId",
    "disableNonDefaultSuggestions",
    "languageCode",
    "isPopupOpen",
    "filter",
    "isLoading",
    "hasDefaultValues"
  ],
  data() {
    return {
      suggestValues: [],
      focusedItemIndex: 0,
      displayValues: [],
      displayValuesWithValue: []
    };
  },
  methods: {
    getSuggestValues: async function (force) {
      if (!this.attributeType || !this.field || !this.attributeId || !this.languageCode) return;

      if (!this.suggestValues.length || this.suggestValues.length >= 50 || force) {
        this.$emit("update:isLoading", true);
        this.displayValues = await suggestapi.suggest[this.attributeType][this.field].get(
          this.languageCode,
          this.attributeId,
          this.filter,
          50,
          this.disableNonDefaultSuggestions
        );
        if (!this.filter && this.displayValues.length < 50) this.suggestValues = this.displayValues;
      } else {
        this.displayValues = this.suggestValues.filter((x) => x.value.toUpperCase().includes(this.filter.toUpperCase()));
      }
      this.focusedItemIndex = 0;
      this.$emit("update:isLoading", false);
      this.displayValuesWithValue = (this.displayValues || []).filter((item) => item && (item.value || (this.hasDefaultValues && item.count === -1)));
    },
    onValueSelected(args) {
      this.$emit("input", args);
      this.$emit("update:isPopupOpen", false);
    },

    focusItem(index) {
      if (this.displayValuesWithValue.length > 0) {
        this.$refs.suggestValues[index].focus();
        this.$refs.suggestValues[index].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest"
        });
      }
    },
    onArrowUp() {
      if (this.focusedItemIndex > 0) {
        this.focusedItemIndex--;
        this.focusItem(this.focusedItemIndex);
      }
    },
    onArrowDown() {
      if (this.focusedItemIndex < this.displayValuesWithValue.length - 1) {
        this.focusedItemIndex++;
        this.focusItem(this.focusedItemIndex);
      }
    }
  },
  watch: {
    isPopupOpen: {
      immediate: true,
      handler: async function (nv) {
        if (nv) {
          await this.getSuggestValues(true);
          if (this.displayValuesWithValue.length > 0) this.focusItem(this.focusedItemIndex);
        }
      }
    },
    filter: {
      immediate: true,
      handler: async function () {
        if (this.isPopupOpen) {
          await this.getSuggestValues(false);
        }
      }
    }
  }
};
</script>
